import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { updateLayoutConfiguration } from 'actions/layoutConfiguration';
import RoundButton from 'components/ui/roundButton';

export const SearchFilterToggle: FC = () => {
  const dispatch = useDispatch();
  const isSearchExpanded = useSelector(
    (state: RootState) => state.layoutConfiguration.isSearchExpanded
  );

  const handleClick = () => {
    dispatch(
      updateLayoutConfiguration({ isSearchExpanded: !isSearchExpanded })
    );
  };

  return (
    <RoundButton
      id='search-button'
      icon='search'
      iconSize={16}
      size={30}
      status={'none'}
      onClick={handleClick}
    />
  );
};
